import * as React from "react";
import { cn } from "@/lib/utils";

// Ported from careers.co.jp v2 EmptyState — dashed border, icon disc, title,
// short body and an optional action that teaches the next step.

export interface EmptyStateProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
  icon?: React.ReactNode;
  title: React.ReactNode;
  body?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState = React.forwardRef<HTMLDivElement, EmptyStateProps>(
  ({ icon, title, body, action, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn(
        "flex flex-col items-center justify-center rounded-lg border border-dashed border-border-2 bg-surface px-6 py-12 text-center",
        className,
      )}
      {...props}
    >
      {icon ? (
        <div className="mb-3 inline-flex h-10 w-10 items-center justify-center rounded-full bg-surface-2 text-text-2">
          {icon}
        </div>
      ) : null}
      <p className="font-display text-lg font-semibold leading-snug text-text">{title}</p>
      {body ? <p className="mt-1.5 max-w-md text-sm text-text-2">{body}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  ),
);
EmptyState.displayName = "EmptyState";
